import find from 'lodash/find'
import forEach from 'lodash/forEach'
import remove from 'lodash/remove'
import cloneDeep from 'lodash/cloneDeep'

import { ProductCollectionItemPublic } from '@cms-labs/typescript-api/products/types'
import { CartItem } from './types'

class Cart {
  items: CartItem[] = []

  public constructor () {
    if (localStorage.getItem('cartItems')) {
      try {
        const itemsRaw = localStorage.getItem('cartItems')
        this.items = itemsRaw !== null ? JSON.parse(itemsRaw) : []
      } catch (err) {
        localStorage.removeItem('cartItems')
      }
    }
  }

  public emptyCart () {
    if (localStorage.getItem('cartItems')) {
      localStorage.removeItem('cartItems')
      this.items = []
    }
  }

  private commit () {
    localStorage.setItem('cartItems', JSON.stringify(this.items))
  }

  public get itemsCount (): number {
    let count = 0
    if (this.items.length) {
      forEach(this.items, item => { count += item.quantity })
    }
    return count
  }

  public get orderTotal (): number {
    let total = 0
    forEach(this.items, (item) => {
      total += (item.quantity * item.price)
    })
    return total
  }

  public addItem (item: ProductCollectionItemPublic, qty = 1) {
    const existingProd = find(this.items, { uuid: item.uuid })
    if (existingProd) {
      existingProd.quantity += qty
    } else {
      this.items.push({ ...item, quantity: qty })
    }
    this.commit()
  }

  public removeItem (uuid: string) {
    const itemsCopy = cloneDeep(this.items)
    remove(itemsCopy, { uuid: uuid })
    this.items = itemsCopy
    this.commit()
  }

  public updateItemQuantity (uuid: string, qty: number) {
    if (Number.isInteger(qty) && qty > 0) {
      const item = find(this.items, { uuid: uuid })
      if (item) {
        item.quantity = qty
        this.commit()
      }
    }
  }
}

export default new Cart()
